if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        // BUG (post-LIVE 2026-06-02): browser extensions (Honey / Capital
        // One Shopping) instantiate <product-form> elements with no inner
        // <form>, so querySelector("form") is null and the next line threw
        // "Cannot read properties of null" 300+ times. Bail out cleanly.
        if (!this.form) return;
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        
        const showErrorHidden = document.querySelectorAll(".hidden__err");

        showErrorHidden.forEach((f) => (f.style.display = "none"));

        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        let quantity = parseFloat(formData.get("quantity"))
        const productId = parseFloat(formData.get("product-id"))

        const cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => data);

        let isCheckMaxQuantity = false
        const maxQuantity = document.querySelector(
          `.hidden__temp--${productId}`
        );

        const currentSize = formData.get('Size')
        
        const maxQuantityFormat = parseFloat(maxQuantity.textContent);
        
        for(let i = 0; i < cartContents.items?.length; i++) {
          
          let isCheckCart = false;
          if(currentSize) {
            isCheckCart = cartContents.items[i].product_id  === productId && (currentSize === cartContents.items[i].options_with_values[0]?.value || currentSize === cartContents.items[i].options_with_values[0])
          } else {
            isCheckCart = cartContents.items[i].product_id  === productId
          }
          
          if(isCheckCart) {
            const totalQuantityCart = cartContents.items[i].quantity + quantity
            
            const currentQuantityCart = cartContents.items[i].quantity
            if(totalQuantityCart > maxQuantityFormat || currentQuantityCart > maxQuantityFormat) {
              isCheckMaxQuantity = true
            }
            break;
          }
        }
       
        if (isCheckMaxQuantity || (quantity > maxQuantityFormat)) {
          
          const showError = this.querySelector(`.show__err--${productId}`);
          showError.style.display = "block";
          showError.innerHTML = `Limit of ${maxQuantityFormat} for order, check in cart`;
  
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.querySelector(".wbquicksuccess").classList.add("hidden"); // Webibazaar Quickview Message
                this.handleErrorMessage(response.description);
                return;
              }

              quantity = response.quantity
              
              if (quantity > maxQuantityFormat) {
                const showError = this.querySelector(
                  `.show__err--${productId}`
                );
                showError.style.display = "block";
                showError.innerHTML = `Limit of ${maxQuantityFormat} for order, check in cart`;

                submitButton.classList.remove("loading");
                submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
              } else {

              this.cartNotification.renderContents(response);
              this.querySelector(".wbquicksuccess").classList.remove("hidden"); // Webibazaar Quickview Message
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
               
                submitButton.classList.remove("loading");
                submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
              
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
